import React, { useContext, useEffect, useRef, useState } from 'react'
import { stateContext } from './Context'
import { findAllOccurrences } from './EditorPage'
import '../assets/stylesheets/FindandReplace.css'


export const FindandReplace = () => {

    const findInput = useRef()
    const replaceInput = useRef()
    
    let { setShowFindnReplace,
        showFindnReplace,
        quill,
        quillTextWithoutMedia
    } = useContext(stateContext)

    const findnReplaceDiv = useRef()
    let findDiv = findnReplaceDiv.current
    const [text, setText] = useState('')
    useEffect(() => {
        if (showFindnReplace) {
            findInput.current.value = ''
            replaceInput.current.value = ''
            findDiv.classList.remove('find-hide')
            findDiv.classList.add('find-show')
            findInput.current.focus()
            setText(quillTextWithoutMedia())
        } else {
            let div = document.getElementsByClassName('find-show')[0]
            if (div) {
                div.classList.remove('find-show')
                findDiv.classList.add('find-hide')
            }
      }
    }, [showFindnReplace])
    

    const [indexList, setIndexList] = useState([])
    const [word, setWord] = useState('')
    const prevList = useRef([])
    const prevWord = useRef('')
    let findIndex = []
    const find = (e) => {
        // console.log(e.target.value.toLowerCase())
        if (findInput.current.value) {
            let inputWord = findInput.current.value.toLowerCase()
            findIndex = findAllOccurrences(text, inputWord)
            // console.log(findIndex)
            setWord(inputWord)
            setIndexList(findIndex)
        } else {
            setIndexList([])
        }
    }

    useEffect(() => {
        prevList.current = indexList
        indexList.forEach((each) => {
            quill.formatText(each, word.length, {
                background: "#79c679",
            }); 
        })
    }, [indexList])

    useEffect(() => {
        prevWord.current = word
    }, [word])
    
    
    if (prevList.current.length) {
        prevList.current.forEach((each) => {
            quill.formatText(each, prevWord.current.length, 'background', false)
        })
    }

    const replace = () => {
        let totalText = quillTextWithoutMedia().toLowerCase()
        let ind = totalText.indexOf(findInput.current.value.toLowerCase())
        if (ind !== -1) {
            quill.deleteText(ind, findInput.current.value.length)
            quill.insertText(ind, replaceInput.current.value)
        }
    }


    const replaceText = () => {
        indexList.forEach(index => {
            let totalText = quillTextWithoutMedia().toLowerCase()
            let ind = totalText.indexOf(findInput.current.value.toLowerCase())
            quill.deleteText(ind, findInput.current.value.length)
            quill.insertText(ind, replaceInput.current.value)
        })
        setIndexList([])
    }


  return (
    <div ref={findnReplaceDiv} className='find-reaplce-div'>
        <h3>Find and Replace <span onClick={() => {setShowFindnReplace(!showFindnReplace)}}>&#10006;</span></h3> 
        <input type="text" name="find" placeholder='Find' ref={findInput}
            onChange={find}
            onFocus={() => {setText(quillTextWithoutMedia())}} />
        <input type="text" name="replace_with" placeholder='Replace with' ref={replaceInput}/>  
        <button onClick={replace}>Replace</button>
        <button onClick={replaceText}>Replace All</button>
    </div>
  )
}
